import { Select } from 'uikit';

import React, { useMemo, useCallback, useEffect, useState } from 'react';

import type { ITableLikeTreeFilterItem } from '../context';

import Style from './TopFilter.module.css';

interface ITopFilter {
    items: ITableLikeTreeFilterItem[] | undefined;
    checkedIds: number[];
    onCheckChange: (seasonValues: {
        firstSeason: ITableLikeTreeFilterItem | undefined;
        lastSeason: ITableLikeTreeFilterItem | undefined;
    }) => void;
    title?: string;
    disabled?: boolean;
    isOrderChangePage?: boolean;
    isReadOnly?: boolean;
    noFirstListSelectionInSecond?: boolean;
    isFirstListDisabled?: boolean;
    firstListItems?: ITableLikeTreeFilterItem[];
    secondListItems?: ITableLikeTreeFilterItem[];
}

export const TopFilter = (props: ITopFilter) => {
    const {
        items = [],
        title,
        disabled,
        onCheckChange,
        isOrderChangePage,
        isReadOnly,
        noFirstListSelectionInSecond,
        isFirstListDisabled,
        firstListItems,
        secondListItems,
    } = props;

    const [seasonValues, setSeasonValues] = useState<{
        firstSeason: ITableLikeTreeFilterItem | undefined;
        lastSeason: ITableLikeTreeFilterItem | undefined;
    }>({
        firstSeason: undefined,
        lastSeason: undefined,
    });

    const currentSecondListItems = useMemo(() => {
        if (!noFirstListSelectionInSecond || !seasonValues.firstSeason) {
            return secondListItems || items;
        }

        return (secondListItems || items).filter((i) => i.id !== seasonValues.firstSeason?.id);
    }, [items, noFirstListSelectionInSecond, seasonValues.firstSeason, secondListItems]);

    // TODO: предметно зависимый код в общем компоненте.
    useEffect(() => {
        const value = {
            firstSeason: (firstListItems || items).find((item) => item.isFirstActive),
            lastSeason: currentSecondListItems.find((item) => item.isLastActive),
        };

        setSeasonValues(() => value);
    }, [currentSecondListItems, firstListItems, items]);

    const onSelectChange = useCallback(
        (season: keyof typeof seasonValues) =>
            ({ value }: { value: ITableLikeTreeFilterItem | null }) => {
                setSeasonValues((prevState) => {
                    const newState = { ...prevState, [season]: value ?? undefined };

                    onCheckChange(newState);

                    return newState;
                });
            },
        [onCheckChange],
    );

    return (
        <div className={Style.topFilter}>
            {title && <div className={Style.titleContainer}>{title}</div>}

            <div className={Style.itemsContainer}>
                {
                    // TODO: предметно зависимый код в общем компоненте.
                    isReadOnly ? (
                        `${seasonValues.firstSeason?.title || ''}-${seasonValues.lastSeason?.title || ''}`
                    ) : (
                        <>
                            <Select
                                items={firstListItems || items}
                                value={seasonValues.firstSeason}
                                onChange={onSelectChange('firstSeason')}
                                getItemLabel={(i) => i.title}
                                size="s"
                                disabled={isFirstListDisabled || disabled || isOrderChangePage}
                                dropdownClassName="dropdownContainer"
                            />
                            <Select
                                items={currentSecondListItems}
                                value={seasonValues.lastSeason}
                                onChange={onSelectChange('lastSeason')}
                                getItemLabel={(i) => i.title}
                                size="s"
                                disabled={disabled}
                                dropdownClassName="dropdownContainer"
                            />
                        </>
                    )
                }
            </div>
        </div>
    );
};

TopFilter.displayName = 'TopFilter';
